import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "wallet",
  "use": "wallet-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"wallet\">\n    <path d=\"M17.944 8.448H15.0368C14.1808 8.448 13.4868 9.14196 13.4868 9.998C13.4868 10.854 14.1808 11.548 15.0368 11.548H18\" stroke=\"currentColor\" stroke-width=\"1.5\" />\n    <rect x=\"2\" y=\"3\" width=\"16\" height=\"14\" rx=\"4\" stroke=\"currentColor\" stroke-width=\"1.5\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol